import { get } from '../../../helpers/utils/http-client';
import { APPS_ENDPOINT } from '../../../consts/api-endpoints';
import { createPromptConfigTool, updatePromptConfigTool, deletePromptConfigTool } from '../../../services/prompt-ai';

const toolId = id => `playbook-${id}`;
const failure = () => new Error('Could not update the agent connection. Retry saving the playbook settings.');
const succeeded = result => result?.status >= 200 && result.status < 300;

async function existingTool(appId, id) {
    // A failed lookup must not be treated as a missing tool.
    const result = await get(`${APPS_ENDPOINT}/${appId}/prompt-config/tools/${toolId(id)}`);
    if (result.status === 404) return null;
    if (result.status !== 200 || !result.response) throw failure();
    const tool = result.response;
    if (tool.managedByPlaybook !== id) throw failure();
    return tool;
}

export async function syncPlaybookTool(appId, playbook, remove = false) {
    if (!playbook?.id || playbook.authoringMode !== 'playbook') return;
    const existing = await existingTool(appId, playbook.id);
    const description = (playbook.description || '').trim();
    if (remove || !description) {
        if (existing) {
            const result = await deletePromptConfigTool(appId, existing.id);
            if (!succeeded(result) && result?.status !== 404) throw failure();
        }
        return;
    }
    const slug = (playbook.name || 'playbook').toLowerCase().replace(/[^a-z0-9_]+/g, '_').replace(/^_+|_+$/g, '') || 'playbook';
    const suffix = playbook.id.replace(/[^a-zA-Z0-9_-]/g, '_').slice(-24);
    const payload = {
        id: toolId(playbook.id), name: `playbook_${slug.slice(0, 29)}_${suffix}`,
        type: 'workflow', description, parameters: {}, toolData: { workflowId: playbook.id }, managedByPlaybook: playbook.id,
    };
    if (existing && Object.entries(payload).every(([key, value]) => JSON.stringify(existing[key]) === JSON.stringify(value))) return;
    const result = existing
        ? await updatePromptConfigTool(appId, payload.id, payload)
        : await createPromptConfigTool(appId, payload);
    if (!succeeded(result)) throw failure();
}
